import { Network } from 'relay-runtime';
import createFetch from './createFetch';
import createSubscribe from './createSubscribe';

// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function noop() {};

var SimpleNetworkLayer = {
  create: function create(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$url = _ref.url,
        url = _ref$url === void 0 ? '/graphql' : _ref$url,
        subscriptionUrl = _ref.subscriptionUrl,
        throwErrors = _ref.throwErrors,
        authorization = _ref.authorization,
        init = _ref.init,
        batch = _ref.batch,
        maxSubscriptions = _ref.maxSubscriptions;

    var subscribeFn = subscriptionUrl ? createSubscribe({
      token: typeof authorization === 'string' ? authorization : authorization === null || authorization === void 0 ? void 0 : authorization.token,
      maxSubscriptions: maxSubscriptions,
      url: subscriptionUrl
    }) : undefined;
    var network = Network.create(createFetch({
      authorization: authorization,
      throwErrors: throwErrors,
      init: init,
      batch: batch,
      url: url
    }), subscribeFn);
    network.close = (subscribeFn === null || subscribeFn === void 0 ? void 0 : subscribeFn.close) || noop;
    return network;
  }
};
export default SimpleNetworkLayer;